import type { AxiosRequestConfig } from 'axios'
import type RequestFilterChain from '../RequestFilterChain'

import { Leaf7EncryptOptions } from './types'
import sm2 from './smCrypto/sm2'
import sm3 from './smCrypto/sm3'
import { cloneDeep } from 'lodash-es'

export default class Leaf7EncryptRequestParser {
  options: Leaf7EncryptOptions

  constructor(options: Leaf7EncryptOptions) {
    this.options = options
  }

  async doFilter(request: AxiosRequestConfig, chain: RequestFilterChain) {
    // prefix：encryptStringPrefix 加密字符串前缀
    // _s1：sm4Key
    // _s2：sm2PublicKey
    const { prefix, _s1, _s2, _s3, whitelist, contentType = 'application/json' } = this.options
    const { url = '' } = request
    if (whitelist && whitelist.length > 0) {
      let flag = false
      whitelist.forEach((prefix) => {
        if (url.indexOf(prefix) > -1) {
          flag = true
          return false
        }
      })
      if (flag) {
        chain.doFilter(request, chain)
        return
      }
    }

    let requestData
    // FormData一般为上传附件，跳过
    if (request.data instanceof FormData) {
      return chain.doFilter(request, chain)
    } else {
      requestData = cloneDeep(request.data)
      if (requestData == null || requestData == '') {
        return chain.doFilter(request, chain)
      }
      // 组装报文并加密
      const content = prefix + sm2._s2EN(JSON.stringify(requestData), _s2, 0)
      const Timestamp = Math.floor(Date.now() / 1000).toString()
      const mergeStr = Timestamp + content
      const signature = sm3(mergeStr)

      request.data = content

      //按照规范进行前端加密
      request.headers['Web-Encrypt-Response-Encrypt-Key'] = prefix + sm2._s2EN(_s1, _s2, 0)
      request.headers['Web-Encrypt-Timestamp'] = Timestamp
      request.headers['Web-Encrypt-Sign'] = signature
      request.headers['content-type'] = contentType
      if (_s3) {
        request.headers['Web-Encrypt-Caller-Id'] = _s3
      }

      chain.doFilter(request, chain)
    }
  }
}
